import './style.scss';
import { Slider } from '../../../js/components/Slider/Slider';

export default !function () {
  const wrapper = document.querySelector('.process-v1__wrapper');

  if (!wrapper) {
    return;
  }

  const items = wrapper.querySelectorAll('.process-v1__item');
  const options = {
    wrapper,
    lazy: true,
    settings: {
      slideClass: 'process-v1__item',
      wrapperClass: 'process-v1__list',
      loop: false
    },
    initCondition: {
      sm: items.length > 1,
      md: items.length > 1,
      lg: items.length > 1,
      xl: items.length > 4
    }
  };

  new Slider(options).init();
}();
